"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionnaireConditionService = void 0;
var publish_1 = require("../condition/publish");
var questionnaire_condition_context_1 = require("./questionnaire-condition-context");
var taxonomy_condition_context_1 = require("./taxonomy-condition-context");
var answer_condition_context_1 = require("./answer-condition-context");
var advanced_logic_error_1 = require("../util/advanced-logic-error");
var lodash_1 = require("lodash");
var QuestionnaireConditionService = /** @class */ (function (_super) {
    __extends(QuestionnaireConditionService, _super);
    function QuestionnaireConditionService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    QuestionnaireConditionService.prototype.extractValueFromKnowledge = function (knowledge, condition) {
        if (this.isTaxonomyConditionContext(condition)) {
            var context_1 = condition.context;
            return knowledge.taxonomyDevice[context_1.property];
        }
        if (this.isConceptConditionContext(condition)) {
            var context_2 = condition.context;
            if (!knowledge.concepts) {
                return false;
            }
            var answeredConcept = knowledge.concepts.find(function (answeredConcept) {
                return answeredConcept.nodeId === context_2.nodeId;
            });
            if (answeredConcept) {
                return answeredConcept.conceptIds;
            }
        }
        if (this.isAnswerConditionContext(condition)) {
            var context_3 = condition.context;
            var allQuestionAnswers = __spreadArrays(knowledge.questionAnswers, (knowledge.screeningQuestionAnswers || []));
            var qas = allQuestionAnswers.find(function (qa) {
                return qa.questionId === context_3.questionId;
            });
            if (!qas) {
                // There is a scenario where a researcher may have "optional" paths
                // where they still need to run evaluations to
                // ie: given survey Q1 -> Q2 -> Q4
                //                     -> Q3 -> Q4
                // and we want to say at Q4 if answer at Q3 was X then do something
                // this means that if we go to Q4 from Q2, then Q3 will be missing, so we want the
                // rule to just return false, instead of crashing
                // we don't want to crash when trying to eval a
                return false;
                // throw new AdvancedLogicError('Missing qas');
            }
            if (condition.matcher === publish_1.Matcher.Contains) {
                return qas.answers.map(function (answer) {
                    var text = answer.text;
                    if (!lodash_1.isString(text)) {
                        throw new advanced_logic_error_1.AdvancedLogicError("Contains valueToCheck should be type string, received " + typeof text);
                    }
                    return text;
                });
            }
            if (condition.matcher === publish_1.Matcher.NotContains) {
                return qas.answers.map(function (answer) {
                    var text = answer.text;
                    if (!lodash_1.isString(text)) {
                        throw new advanced_logic_error_1.AdvancedLogicError("Not Contains valueToCheck should be type string, received " + typeof text);
                    }
                    return text;
                });
            }
            if (context_3.valueType === 'number') {
                return qas.answers.map(function (answer) {
                    var text = answer.text;
                    if (lodash_1.isUndefined(text)) {
                        throw new advanced_logic_error_1.AdvancedLogicError(condition.matcher + " expects answer.text to exist for answer " + JSON.stringify(answer, null, 2));
                    }
                    var number = parseFloat(text);
                    if (!lodash_1.isFinite(number)) {
                        throw new advanced_logic_error_1.AdvancedLogicError(condition.matcher + " answer.text should be a valid number, received " + text + " of type " + typeof text);
                    }
                    return number;
                });
            }
            if (context_3.valueType === 'text') {
                return qas.answers.map(function (answer) {
                    var text = answer.text;
                    if (lodash_1.isUndefined(text)) {
                        throw new advanced_logic_error_1.AdvancedLogicError(condition.matcher + " expects answer.text to exist for answer " + JSON.stringify(answer, null, 2));
                    }
                    return text;
                });
            }
            if (context_3.valueType === 'matrix') {
                return qas.answers.map(function (answer) {
                    var row = answer.row, column = answer.column;
                    if (lodash_1.isUndefined(row)) {
                        throw new advanced_logic_error_1.AdvancedLogicError(condition.matcher + " expects answer.row to exist for answer " + JSON.stringify(answer, null, 2));
                    }
                    if (lodash_1.isUndefined(column)) {
                        throw new advanced_logic_error_1.AdvancedLogicError(condition.matcher + " expects answer.column to exist for answer " + JSON.stringify(answer, null, 2));
                    }
                    return { row: row, column: column };
                });
            }
            if (context_3.valueType === 'matrixBipolar') {
                return qas.answers.map(function (answer) {
                    var row = answer.row, column = answer.column, text = answer.text;
                    if (lodash_1.isUndefined(row)) {
                        throw new advanced_logic_error_1.AdvancedLogicError(condition.matcher + " expects answer.row to exist for answer " + JSON.stringify(answer, null, 2));
                    }
                    if (lodash_1.isUndefined(column)) {
                        throw new advanced_logic_error_1.AdvancedLogicError(condition.matcher + " expects answer.column to exist for answer " + JSON.stringify(answer, null, 2));
                    }
                    if (lodash_1.isUndefined(text)) {
                        throw new advanced_logic_error_1.AdvancedLogicError(condition.matcher + " expects answer.text to exist for answer " + JSON.stringify(answer, null, 2));
                    }
                    var number = parseFloat(text);
                    if (!lodash_1.isFinite(number)) {
                        throw new advanced_logic_error_1.AdvancedLogicError(condition.matcher + " answer.text should be a valid number, received " + text + " of type " + typeof text);
                    }
                    return { row: row, column: column, value: number };
                });
            }
            if (context_3.valueType === 'matrixNumericOpenEnded') {
                return qas.answers.map(function (answer) {
                    var row = answer.row, column = answer.column, text = answer.text;
                    if (lodash_1.isUndefined(row)) {
                        throw new advanced_logic_error_1.AdvancedLogicError(condition.matcher + " expects answer.row to exist for answer " + JSON.stringify(answer, null, 2));
                    }
                    if (lodash_1.isUndefined(column)) {
                        throw new advanced_logic_error_1.AdvancedLogicError(condition.matcher + " expects answer.column to exist for answer " + JSON.stringify(answer, null, 2));
                    }
                    if (lodash_1.isUndefined(text)) {
                        throw new advanced_logic_error_1.AdvancedLogicError(condition.matcher + " expects answer.text to exist for answer " + JSON.stringify(answer, null, 2));
                    }
                    var number = parseFloat(text);
                    if (!lodash_1.isFinite(number)) {
                        throw new advanced_logic_error_1.AdvancedLogicError(condition.matcher + " answer.text should be a valid number, received " + text + " of type " + typeof text);
                    }
                    return { row: row, column: column, value: number };
                });
            }
            return qas.answers.map(function (answer) { return answer.id; });
        }
        return false;
    };
    QuestionnaireConditionService.prototype.isTaxonomyConditionContext = function (condition) {
        var _a;
        return (((_a = condition.context) === null || _a === void 0 ? void 0 : _a.contextType) === questionnaire_condition_context_1.QuestionnaireConditionContext.Taxonomy);
    };
    QuestionnaireConditionService.prototype.isConceptConditionContext = function (condition) {
        var _a;
        return (((_a = condition.context) === null || _a === void 0 ? void 0 : _a.contextType) === questionnaire_condition_context_1.QuestionnaireConditionContext.Concept);
    };
    QuestionnaireConditionService.prototype.isAnswerConditionContext = function (condition) {
        var _a;
        return (((_a = condition.context) === null || _a === void 0 ? void 0 : _a.contextType) === questionnaire_condition_context_1.QuestionnaireConditionContext.Answer);
    };
    QuestionnaireConditionService.prototype.createAnswerConditionEqual = function (questionId, value, id, referencedQuestion, valueType) {
        return this.createAnswerCondition(questionId, value, publish_1.Matcher.Equal, valueType || typeof value, id, referencedQuestion);
    };
    QuestionnaireConditionService.prototype.createAnswerConditionNotEqual = function (questionId, value, id, referencedQuestion, valueType) {
        return this.createAnswerCondition(questionId, value, publish_1.Matcher.NotEqual, valueType || typeof value, id, referencedQuestion);
    };
    QuestionnaireConditionService.prototype.createAnswerConditionIn = function (questionId, value, id, referencedQuestion) {
        return this.createAnswerCondition(questionId, value, publish_1.Matcher.In, typeof value, id, referencedQuestion);
    };
    QuestionnaireConditionService.prototype.createAnswerConditionNotIn = function (questionId, value, id, referencedQuestion) {
        return this.createAnswerCondition(questionId, value, publish_1.Matcher.NotIn, typeof value, id, referencedQuestion);
    };
    QuestionnaireConditionService.prototype.createAnswerConditionContains = function (questionId, value, id, referencedQuestion) {
        return this.createAnswerCondition(questionId, value, publish_1.Matcher.Contains, typeof value, id, referencedQuestion);
    };
    QuestionnaireConditionService.prototype.createAnswerConditionNotContains = function (questionId, value, id, referencedQuestion) {
        return this.createAnswerCondition(questionId, value, publish_1.Matcher.NotContains, typeof value, id, referencedQuestion);
    };
    QuestionnaireConditionService.prototype.createAnswerConditionContainsWord = function (questionId, value, id, referencedQuestion, denominator) {
        return this.createAnswerCondition(questionId, value, publish_1.Matcher.ContainsWord, typeof value, id, referencedQuestion, denominator);
    };
    QuestionnaireConditionService.prototype.createAnswerConditionGreaterThan = function (questionId, value, id, referencedQuestion) {
        return this.createAnswerCondition(questionId, value, publish_1.Matcher.GreaterThan, typeof value, id, referencedQuestion);
    };
    QuestionnaireConditionService.prototype.createAnswerConditionLowerThan = function (questionId, value, id, referencedQuestion) {
        return this.createAnswerCondition(questionId, value, publish_1.Matcher.LowerThan, typeof value, id, referencedQuestion);
    };
    QuestionnaireConditionService.prototype.createAnswerConditionGreaterThanEqual = function (questionId, value, id, referencedQuestion) {
        return this.createAnswerCondition(questionId, value, publish_1.Matcher.GreaterThanEqual, typeof value, id, referencedQuestion);
    };
    QuestionnaireConditionService.prototype.createAnswerConditionLowerThanEqual = function (questionId, value, id, referencedQuestion) {
        return this.createAnswerCondition(questionId, value, publish_1.Matcher.LowerThanEqual, typeof value, id, referencedQuestion);
    };
    QuestionnaireConditionService.prototype.createAnswerCondition = function (questionId, value, matcher, valueType, id, referencedQuestion, denominator) {
        var isNullRelatedMatcher = [publish_1.Matcher.IsNull, publish_1.Matcher.IsNotNull].includes(matcher);
        if (valueType === 'object' && value instanceof Array) {
            valueType = 'array';
        }
        if (valueType === 'object' &&
            lodash_1.has(value, 'row') &&
            lodash_1.has(value, 'column') &&
            !lodash_1.has(value, 'number')) {
            valueType = 'matrix';
        }
        if (valueType === 'object' &&
            lodash_1.has(value, 'row') &&
            lodash_1.has(value, 'column') &&
            (lodash_1.has(value, 'number') || (!lodash_1.has(value, 'number') && isNullRelatedMatcher))) {
            valueType = 'matrixNumericOpenEnded';
        }
        if (valueType === 'object' &&
            lodash_1.has(value, 'row') &&
            lodash_1.has(value, 'number') &&
            !lodash_1.has(value, 'column')) {
            valueType = 'matrixBipolar';
        }
        var condition = new publish_1.Condition({
            id: id,
            value: value,
            context: new answer_condition_context_1.AnswerConditionContext(referencedQuestion || questionId, valueType, denominator),
            matcher: matcher,
        });
        return condition;
    };
    QuestionnaireConditionService.prototype.createTaxonomyConditionEqual = function (value, property, id) {
        return this.createTaxonomyCondition(value, property, publish_1.Matcher.Equal, id);
    };
    QuestionnaireConditionService.prototype.createTaxonomyConditionNotEqual = function (value, property, id) {
        return this.createTaxonomyCondition(value, property, publish_1.Matcher.NotEqual, id);
    };
    QuestionnaireConditionService.prototype.createTaxonomyConditionIn = function (value, property, id) {
        return this.createTaxonomyCondition(value, property, publish_1.Matcher.In, id);
    };
    QuestionnaireConditionService.prototype.createTaxonomyConditionNotIn = function (value, property, id) {
        return this.createTaxonomyCondition(value, property, publish_1.Matcher.NotIn, id);
    };
    QuestionnaireConditionService.prototype.createTaxonomyCondition = function (value, property, matcher, id) {
        return new publish_1.Condition({
            id: id,
            value: value,
            context: new taxonomy_condition_context_1.TaxonomyConditionContext(property),
            matcher: matcher,
        });
    };
    QuestionnaireConditionService.prototype.createCondition = function (value, context, matcher, id) {
        var expectedContextTypes = Object.values(questionnaire_condition_context_1.QuestionnaireConditionContext);
        if (context &&
            !expectedContextTypes.includes(context.contextType)) {
            throw new Error("Unexpected context type. Got " + context + " expected one of " + expectedContextTypes);
        }
        return new publish_1.Condition({
            id: id,
            value: value,
            context: context,
            matcher: matcher,
        });
    };
    return QuestionnaireConditionService;
}(publish_1.ConditionService));
exports.QuestionnaireConditionService = QuestionnaireConditionService;
